/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useContext, useMemo } from "react";
import MapPropsContext from "../MapPropsContext";
import { numberWithCommas } from "../../../utils";
import "./WidgetLegend.scss";

const WidgetLegend = ({
  iconLegend,
  iconLegend2,
  fillColorLegend,
  style,
  legendStyle,
  titleColorLegend,
  unitColorLegend,
}) => {
  const { iconDict, mapLayerNames } = useContext(MapPropsContext);

  const isShownLandUsage = mapLayerNames.includes("KCA:group_uq");

  return (
    <div className={"widget-legend"} style={{ ...style }}>
      {isShownLandUsage && (
        <ColorsLegend
          fillColorLegend={[
            ["#f0e649", "주거지역"],
            ["#aede5f", "녹지지역"],
            ["#899eee", "공업지역"],
            ["#f68f9a", "상업지역"],
            ["#f0deb7", "관리지역"],
            ["#bf8040", "농림지역"],
            ["#9fdece", "자연환경보전지역"],
          ]}
          legendStyle={legendStyle}
          unitColorLegend={""}
          titleColorLegend={"용도지역"}
        />
      )}

      <ColorsLegend
        fillColorLegend={fillColorLegend}
        legendStyle={legendStyle}
        unitColorLegend={unitColorLegend}
        titleColorLegend={titleColorLegend}
      />

      <IconsLegend
        iconDict={iconDict}
        iconLegend={iconLegend}
        legendStyle={legendStyle}
      />

      <IconsLegend
        iconDict={iconDict}
        iconLegend={iconLegend2}
        legendStyle={legendStyle}
      />
    </div>
  );
};

function ColorsLegend({
  fillColorLegend,
  legendStyle,
  titleColorLegend,
  unitColorLegend,
}) {
  const fillColorList = useMemo(() => {
    if (fillColorLegend && fillColorLegend.length > 0) {
      // eslint-disable-next-line no-unused-vars
      const [firstIndex, firstValue] = fillColorLegend[0];
      if (typeof firstValue === "string") {
        return fillColorLegend;
      }
      return Object.entries(fillColorLegend).map(([index, value]) => {
        const [color, label] = value;
        const endValue = Math.floor(label);
        const nextIndex = parseInt(index) + 1;
        const beginValue =
          nextIndex === fillColorLegend.length
            ? 0
            : Math.floor(fillColorLegend[nextIndex][1] + 1);
        const rangeVal =
          numberWithCommas(beginValue) +
          unitColorLegend +
          " ~ " +
          numberWithCommas(endValue) +
          unitColorLegend;
        return [color, rangeVal];
      });
    } else {
      return [];
    }
  }, [fillColorLegend]);

  return (
    <>
      {fillColorList.length > 0 && (
        <div>
          <div className="legend" style={{ marginBottom: 4, ...legendStyle }}>
            <ul>
              {titleColorLegend && (
                <li
                  key={titleColorLegend}
                  style={{
                    display: "block",
                    height: 24,
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <span style={{ fontSize: 13 }}>{titleColorLegend}</span>
                </li>
              )}
              {fillColorList.map(([color, boundary], index) => (
                <li key={index} style={{ display: "block" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 48,
                      height: 14,
                      marginRight: 3,
                      backgroundColor: color,
                    }}
                    className="icon"
                  />
                  {Number(boundary) === boundary
                    ? Math.floor(boundary)
                    : boundary}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

function IconsLegend({ iconDict, iconLegend, legendStyle }) {
  const iconList = useMemo(() => {
    // 폴리곤 범례 오류를 위해 조건문을 추가합니다.
    if (iconLegend && Object.keys(iconDict).length > 0) {
      const array = iconLegend.map(([iconCode, iconLabel]) => [
        iconDict[iconCode].data,
        iconLabel,
      ]);
      return [...new Set(array)];
    }
    return [];
  }, [iconDict, iconLegend]);

  return (
    <>
      {iconList.length > 0 && (
        <div className="legendContainer">
          <div className="legend" style={{ marginBottom: 4, ...legendStyle }}>
            <ul>
              {iconList.map(([iconBase64Data, iconLabel], index) => (
                <li key={index}>
                  <img src={iconBase64Data} className="icon" alt={""} />
                  {iconLabel}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default WidgetLegend;
